import React from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router";
import {Breadcrumb, Table, Typography} from "antd";


import Spacer from "components/Spacer";
import Container from "components/Container";

const titles = {
    info1: "Majburiy talabning mazmuni",
    info2: "Majburiy talab belgilangan normativ-huquqiy hujjat (texnik jixatdan tartibga solish sohasidagi normativ hujjat) nomi, rekvizitlari, tarkibiy birligi va unga xavola",
    info3: "Majburiy talabning zarurati, asosligi, dolzarbligi",
    info4: "Majburiy talabning amal qilish muddati",
    info5: "Majburiy talabga rioya qilishi lozim bo`lgan subyektlarning IFUT bo`yicha faoliyat turi",
    info6: "Nazorat (tekshiruv)ning turi, nazorat qilinadigan (litsenziyalash, ruxsat berish va xabardor qilish) faoliyat turining nomi (agar mavjud bo`lsa)",
    info7: "Nazorat (tekshiruv)ni amalga oshiruvchi vakolatli organ",
    info8: "Majburiy talabga muvofiqlik to`g`risidagi ma'lumotlar va hujjatlarni taqdim etadigan vakolatli organ (agar mavjud bo`lsa)",
    info9: "Majburiy talabga rioya qilmaganlik uchun belgilangan javobgarlik choralari, uni qo`llovchi organ, javobgarlik belgilangan normativ-huquqiy hujjatning rekvizitlari, unga xavola",
    info10: "Majburiy talabga rioya qilish bo`yicha qo`llanma (tushuntirish), nazorat qilinadigan shaxslarni xabardor qilish bo`yicha ishlab chiqilgan boshqa hujjatlar to`g`risidagi ma'lumotlar (rekvizitlar va unga havola)",
    info11: "Majburiy talabning qayta ko`rib chiqilishi muddati",
    info12: "Majburiy talab natijasida tadbirkorlik subyekti uchun yuzaga keladigan moliyaviy xarajatlar",
}

const MandatoryRequirementView = () => {
    const {t, i18n} = useTranslation();
    const {id} = useParams();

   const item = JSON.parse(localStorage.getItem(id));

    return (
        <Container>
            <Spacer size={35}/>

            <Breadcrumb separator=">">
                <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
                <Breadcrumb.Item href="/mandatory-requirement">
                    {t("mandatory-requirements")}
                </Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32}/>
            <Typography.Title style={{textAlign: "center"}}>Majburiy talab pasporti</Typography.Title>
            <Spacer size={32}/>

            <Table
                rowKey="title"
                columns={[
                    {
                        render: (text, record, index) => index + 1,
                        width: "4%"
                    },
                    {
                        key: "title",
                        dataIndex: "title",
                        render: (text, record) => <strong>{record.title}</strong>,
                    },
                    {
                        key: "info",
                        dataIndex: "info",
                        width: "50%"
                    },
                ]}
                dataSource={Object.keys(item).filter(k=>k.startsWith("info")).map((key) => {
                    return ({title: titles[key], info: item[key]})

                })}
                pagination={false}
                scroll={{ x: 1400 }}
            />
            <Spacer size={48}/>
        </Container>
    );
};

export default MandatoryRequirementView;
